import Vue from 'vue';
import axios from 'axios';
import route from '@H/route';
import router from '@R';
import { getErrorFromResponse } from '@H/error-codes';

import {
    complete as sharedComplete,
    loadPaymentConfirmation as sharedLoadPaymentConfirmation
} from '../../shared';

export default {
    /**
     * Handles fetching a single-use token and sending the user off to FX blue with the passed token/user_id
     * @param {Object} ctx - Context set by vuex (store)
     */
    async complete(ctx) {
        try {
            await sharedComplete('Enrolment', ctx);
        } catch (err) {
            throw err;
        }
    },

    /**
     * Handles fetching available subscriptions.
     * @param {Object} ctx - Context set by vuex (store)
     */
    loadSubscriptions(ctx) {
        let { $gettext } = this._vm;
        axios
            .get(route('subscriptions.available'))
            .then(res => {
                ctx.commit('subscriptions', res.data.subscriptions);
            })
            .catch(err => {
                ctx.dispatch(
                    'Flash/setFlash',
                    {
                        message: $gettext(
                            'There was a problem loading subscription data.'
                        )
                    },
                    { root: true }
                );
            });
    },

    /**
     * Handles fetching current subscription product.
     * @param {Object} ctx - Context set by vuex (store)
     */
    loadProduct(ctx) {
        let { $gettext } = this._vm;
        axios
            .get(route('subscriptions.product'))
            .then(res => {
                ctx.commit('product', res.data.product);
            })
            .catch(err => {
                ctx.dispatch(
                    'Flash/setFlash',
                    {
                        message: $gettext(
                            'There was a problem loading subscription data.'
                        )
                    },
                    { root: true }
                );
            });
    },

    /**
     * Load payment confirmation data
     * @param {Object} ctx - Context set by vuex (store)
     */
    async loadPaymentConfirmation(ctx) {
        const { $gettext } = this._vm;
        await sharedLoadPaymentConfirmation('Enrolment', $gettext, ctx);
    },

    setUser(ctx, payload) {
        if (typeof payload.language != 'undefined' && payload.language) {
            ctx.dispatch('setLanguage', payload.language, { root: true });
        }

        ctx.commit('setUser', payload);
    },

    setField(ctx, payload) {
        ctx.commit(payload.identifier, payload.data);
    },

    resetHomeFields(ctx) {
        ctx.commit('clearHomeAddressFields');
    },

    resetBillingFields(ctx) {
        ctx.commit('clearBillingAddressFields');
    },

    setBillingFields(ctx, payload) {
        ctx.commit('setBillingFields', payload);
    },

    setPurchaseOption(ctx, payload) {
        ctx.commit('setPurchaseOption', payload);
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/Enrolment/actions.js